import React, { useMemo, useState } from 'react'
import { Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { formatCommonAmount } from '../../../util/formatAmount'
import styles from '../vendorsListPage.module.scss'
import packageStyles from './Package.module.scss'
import { truncateText } from '../../../util'

const PackageSummary = ({ selectedPackage }) => {
	const [showAddOnDetails, setShowAddOnDetails] = useState(false)

	const handleShowAddOnDetails = () => setShowAddOnDetails((prev) => !prev)

	const packageSummary = useMemo(() => {
		if (!selectedPackage || !Object.keys(selectedPackage).length) return []

		const selectedAddOns = selectedPackage?.addOnsIds?.filter((addon) =>
			selectedPackage?.selectedAddOns?.includes(addon?._id)
		)
		const selectedAddOnsTotal =
			selectedAddOns?.reduce((sum, addon) => {
				const minQuantity = !!addon?.minQuantity
					? parseInt(addon?.minQuantity)
					: 1
				let quantity = addon?.quantity
					? parseInt(addon?.quantity)
					: minQuantity
				return sum + parseFloat(addon?.price) * quantity
			}, 0) || 0

		return [
			{
				heading: 'Package',
				value: `${truncateText(selectedPackage?.name)} - ${formatCommonAmount(selectedPackage?.price)}`,
			},
			selectedAddOns?.length > 0 && {
				heading: 'Add-ons',
				value: formatCommonAmount(selectedAddOnsTotal),
				showDropdown: true,
			},
			...(showAddOnDetails
				? selectedAddOns?.map((addon) => {
						const minQuantity = !!addon?.minQuantity
							? parseInt(addon?.minQuantity)
							: 1
						let quantity = addon?.quantity
							? parseInt(addon?.quantity)
							: minQuantity
						return {
							heading: truncateText(addon?.name),
							value: `${quantity > 1 ? `(Quantity: ${quantity})` : ''}   ${formatCommonAmount(addon?.price)}`,
							isDropdownValue: true,
						}
					})
				: []),
		]
	}, [selectedPackage, showAddOnDetails])

	const totalPrice = useMemo(() => {
		if (!selectedPackage) return 0

		const packagePrice = parseFloat(selectedPackage?.price) || 0

		const selectedAddOnsTotal =
			selectedPackage?.selectedAddOns?.reduce((sum, addonId) => {
				const addon = selectedPackage?.addOnsIds?.find(
					(a) => a?._id === addonId
				)
				const addonPrice = parseFloat(addon?.price) || 0
				const minQuantity = !!addon?.minQuantity
					? parseInt(addon?.minQuantity)
					: 1
				let quantity = addon?.quantity
					? parseInt(addon?.quantity)
					: minQuantity
				return sum + addonPrice * quantity
			}, 0) || 0

		return packagePrice + selectedAddOnsTotal
	}, [selectedPackage])

	if (!selectedPackage || !Object.keys(selectedPackage).length) {
		return null
	}

	return (
		<>
			<ul
				style={{
					borderBottom: '1px solid #DFE4EB',
					paddingBottom: '16px',
					marginBottom: '16px',
				}}
			>
				{packageSummary.map((item) => (
					<li key={item.heading}>
						{item?.showDropdown ? (
							<span
								className={`${styles.heading} ${packageStyles.showDetails}`}
								onClick={handleShowAddOnDetails}
							>
								{item.heading}{' '}
								{showAddOnDetails ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</span>
						) : (
							<span
								className={`${item?.isDropdownValue ? packageStyles.dropDownAddOn : styles.heading}`}
							>
								{item.heading}
							</span>
						)}
						<span
							className={`${item?.isDropdownValue ? packageStyles.dropDownAddOn : styles.value}`}
						>
							{item.value}
						</span>
					</li>
				))}
			</ul>
			<div
				className={packageStyles.totalPriceWrp}
				style={{ backgroundColor: '#FAF4F2' }}
			>
				<Typography
					variant="body2"
					className={packageStyles.totalPriceWrpText}
				>
					Package{' '}
					{selectedPackage?.selectedAddOns?.length > 0
						? '& Add-ons'
						: ''}{' '}
					Price
				</Typography>
				<Typography
					variant="body2"
					className={packageStyles.totalPriceWrpValue}
				>
					Total: {formatCommonAmount(totalPrice)}
				</Typography>
			</div>
		</>
	)
}

export default PackageSummary
